import usePage from '@discover-data/stores/hooks/page/usePage';
import Button from '@discover-ui/button';
import { wait } from '@restaurant-store-utils';

export default function AbortTestButton() {
  const { nextPage } = usePage();
  return (
    <Button
      scale="sm"
      className="self-start"
      onClick={async () => {
        let count = 0;
        while (count < 5) {
          count += 1;
          nextPage();

          await wait(70);
        }
      }}>
      Abort Controller
    </Button>
  );
}
